import { Component } from "~/ecs/base"

export class Impactable extends Component {}
